export const startSocketActionType = "socket/start";
export const stopSocketActionType = "socket/stop";
export const socketConnectedActionType = "ws:connect";
export const setSocketActionType = "socket/set";
